export class AlterarNumeracaoModel {
    constructor(
        public serie: number = 0,
        public nnf: number = 0,
    ) { }
}
